import { TLMiddleLogo } from '@components'
import React from 'react'
import ConsentLogos from '../ConsentLogos'

function ConsentLogosTLCheck() {
  return <ConsentLogos middleLogo={<TLMiddleLogo />} />
}

export default ConsentLogosTLCheck
